import * as Yup from 'yup'

export const avaliacaoSchema = Yup.object().shape({
  questoes: Yup.array().of(Yup.string().required('Selecione uma alternativa'))
})
